<div class="container">
    <h1 class="display-6 d-block">Kuponok</h1>
    
    <dx-data-grid id="gridContainer"
    [dataSource]="dataSource"
    [remoteOperations]="false"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    (onRowValidating)="onRowValidating($event)"
    (onEditorPreparing)="onEditorPreparing($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onEditingStart)="onEditingStart($event)">

    > 
    <dxo-editing 
    mode="row"
    [allowUpdating]="true"
    [allowDeleting]="true"
    [allowAdding]="true"
    [useIcons]="true">
   </dxo-editing>

    <dxi-column dataField="couponId" caption= "Kód" dataType="string">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule type="async" ignoreEmptyValue="true"
            [validationCallback]="asyncCouponCodeValidation" width="40">
        </dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="description" caption= "Megnevezés" dataType="string" [width]="420">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="validFrom" caption= "Érvényesség" dataType="date">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="validTo" caption= "" dataType="date">
        <dxi-validation-rule type="required"></dxi-validation-rule>
     </dxi-column>
    <dxi-column dataField="month" caption= "Hónap" dataType="number">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule type="range" [max]=24 [min]=1 message="Érték 1-24-ig lehet!"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="limit" caption= "Limit" dataType="number">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule type="range" [max]=10000 [min]=1 message="Érték 1-10000-ig lehet!"></dxi-validation-rule>
   </dxi-column>
</dx-data-grid>
</div>
